<div class="otp-dialog-container">
  <button class="close-btn" mat-icon-button (click)="closeOtpDialog()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="otp-content text-center">
    <h5 class="otp-title">
      {{ 'account.otp.sentTo' | translate }}
      <strong>**{{ phoneSuffix }}</strong>
    </h5>
    <p class="otp-subtitle" translate>account.otp.verifyIdentity</p>

    <div class="d-flex justify-content-center my-3">
      <ng-otp-input
        class="text-center"
        [formCtrl]="otpControl"
        [config]="otpConfig"
        dir="ltr"
      ></ng-otp-input>
    </div>

    <div *ngIf="error" class="mb-2">
      <p class="input-error">{{ error }}</p>
    </div>

    <div class="resend-section text-secondary mb-3">
      <div translate>Didn't receive the OTP yet?</div>
      <span *ngIf="isTimerActive" class="fw-600">
        <span translate>Resend OTP in </span>
        {{ getTimerText(timer) | numberTranslate }}
      </span>
      <a
        class="resend-otp-link c-pointer"
        *ngIf="!isTimerActive && !isResending"
        (click)="resendOtp()"
        translate
        >Resend OTP?</a
      >
    </div>

    <button
      class="w-100"
      color="primary"
      mat-flat-button
      [disabled]="isSubmitting || otpControl.value?.length < 6"
      (click)="submitOtp()"
      appTrackClick="otp-submit-btn"
      ctaType="primary"
    >
      <span translate>account.otp.verify</span>
      <app-loader class="d-inline-flex" [isLoading]="isSubmitting"></app-loader>
    </button>
  </div>
</div>
